import { render, staticRenderFns } from "./IsTransferred.vue?vue&type=template&id=acd7ca78&"
import script from "./IsTransferred.vue?vue&type=script&lang=js&"
export * from "./IsTransferred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports